import Api from '@/api/Api'
import store from '../store'

export default {

  async getAll (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('purchases', { params }))
  },

  async getSingle (params) {
    return store.dispatch('checkResponseApi', await Api().get('purchase', { params }))
  },

  async insert (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('purchase', data, options))
  },

  async update (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('purchase', data, options))
  },

  async updateStatus (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('purchase/status', data, options))
  },

  async delete (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().delete('purchase', { data: data }, options))
  },

  async getLatestCode (params) {
    return store.dispatch('checkResponseApi', await Api().get('purchase/latest_code', { params }))
  },
}



// WEBPACK FOOTER //
// ./src/api/PurchaseService.js